class Overlay
    constructor: (el) ->
        @.$el = el
        @.$el.classList.add 'overlay__template--bound'
        @.$scrollBar = undefined
        @.$overlayEl = null

        @.closeDelay = 300
        @.closeOnlyViaButton = @.$el.classList.contains 'overlay__template--covb'
        @.closeInterval = undefined
        @.id = if @.$el.id then @.$el.id else window.appUtils.GenerateId('overlay-')
        @.redirectOnClose = false
        @.resizeDelay = 300
        @.resizeInterval = undefined
        @.show = @.$el.classList.contains 'overlay__template--show'
        @.shown = false

        @.$el.id = @.id
        @.InitEvents()

        if @.show
            @.ShowOverlay()
        # check if an hash matching the overlay id is present to auto open it if so
        @.CheckForHashToOpen()
        return

    CheckForHashToOpen: ->
        self = @
        if @.id && !@.shown
            hashes = window.location.hash.split('#')
            hashes.forEach (hash) ->
                if self.id == hash
                    self.ShowOverlay()
        return

    CheckForOtherOpenOverlay: ->
        document.querySelectorAll '.overlay'
            .forEach (overlay) ->
                overlay.dispatchEvent new CustomEvent 'overlay-close', { bubbles: false }
                return
        return

    CloseOverlay: ->
        self = @
        if @.$overlayEl
            @.$overlayEl.classList.remove 'overlay--open'
            window.clearInterval @.closeInterval
            @.closeInterval = window.setInterval ->
                window.clearInterval self.closeInterval
                self.$overlayEl.remove()
                self.$overlayEl = null
                self.$scrollBar = undefined
                siteEl = document.getElementById 'site'
                if siteEl
                    siteEl.classList.remove 'site--overlay-open'
                    siteEl.dispatchEvent new CustomEvent 'site-set-scroll-state', {
                        bubbles: false,
                        detail: {
                            deprive: false
                        }
                    }
                if self.redirectOnClose
                    if self.redirectOnClose == "reload"
                        window.location.reload()
                    else
                        window.location = self.redirectOnClose
                self.shown = false
                return
            , @.closeDelay
        return
    
    InitEvents: ->
        self = @
        @.$el.addEventListener 'overlay-show', (e) ->
            self.ShowOverlay()
            return
        @.$el.addEventListener 'overlay-close', (e) ->
            self.CloseOverlay()
            return
        @.$el.addEventListener 'overlay-set-redirect-on-close', (e) ->
            self.redirectOnClose = e.detail?.redirectOnClose ? false
            return
        return
    
    InitOverlayEvents: ->
        self = @
        if @.$overlayEl
            @.$overlayEl.addEventListener 'overlay-close', (e) ->
                self.CloseOverlay()
                return
            if !@.closeOnlyViaButton
                @.$overlayEl.addEventListener 'click', (e) ->
                    if !e.target.closest('.overlay__window')
                        self.CloseOverlay()
                    return
            @.$overlayEl.querySelector '.overlay__closer'
                .addEventListener 'click', (e) ->
                    e.preventDefault()
                    self.CloseOverlay()
                    return
        return
    
    ShowOverlay: ->
        @.CheckForOtherOpenOverlay()
        siteEl = document.getElementById 'site'
        if siteEl
            #siteEl.dataset.lastScroll = window.scrollY
            siteEl.classList.add 'site--overlay-open'
            siteEl.dispatchEvent new CustomEvent 'site-set-scroll-state', {
                bubbles: false,
                detail: {
                    deprive: true
                }
            }
            overlayTarget = siteEl
        else
            overlayTarget = document.querySelector 'body'
        overlayTarget.appendChild document.importNode(@.$el.content, true)
        @.$overlayEl = overlayTarget.querySelector '.overlay'
        @.$overlayEl.id = "overlay-id_#{ @.id }"
        @.$overlayEl.dataset.id = @.id
        @.$overlayEl.classList.add 'overlay--open'
        @.InitOverlayEvents()
        @.shown = true
        window.dispatchEvent new CustomEvent 'bind-components', {bubbles: false}
        return

BindOverlays = ->
    document.querySelectorAll '.overlay__template:not(.overlay__template--bound)'
        .forEach (el) ->
            new Overlay el
            return
    return

window.addEventListener 'bind-components', BindOverlays


class OverlayCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.bindLater = options?.bindLater ? false
        @.closeOnlyViaButton = options?.closeOnlyViaButton ? false
        @.closeText = options?.closeText ? 'Schließen'
        @.content = options?.content ? ''
        @.id = options?.id ? false
        @.show = options?.show ? false

        @.CreateElement()
        if !@.bindLater
            new Overlay @.$el
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement 'template'
        @.$el.classList.add 'overlay__template'
        if @.id
            @.$el.id = @.id
        if @.closeOnlyViaButton
            @.$el.classList.add 'overlay__template--covb'
        if @.show
            @.$el.classList.add 'overlay__template--show'
        @.$el.innerHTML = "
            <div class='overlay'>
                <div class='overlay__window'>
                    <button class='overlay__closer' aria-label='#{ @.closeText }' title='#{ @.closeText }' type='button'>
                        <span class='icon-close-delete'></span>
                    </button>
                    <div class='overlay__content'>#{ @.content }</div>
                </div>
            </div>
        "
        overlayEl = @.$el.querySelector '.overlay'
        if @.attrs
            overlayEl = window.appUtils.Attributes @.attrs, overlayEl
        return

window.CreateOverlay = (options) ->
    return new OverlayCreate options